<template>
  <div style="overflow-y: auto">
    <v-select
      label="Condition Mode"
      class="mr-2"
      style="width: 150px; flex-grow: 0"
      v-model="conditionMode"
      @update:modelValue="UpdateMode"
      density="compact"
      :items="['All', 'Any']"></v-select>
    <ConditionPicker
      itemtype="template"
      :item="userEditObj" />
  </div>
</template>
<script setup>
import { ref, defineProps, onMounted } from 'vue';
import ConditionPicker from '../../Shared/ConditionPicker.vue';

const props = defineProps(['userEditObj']);
const conditionMode = ref('All');

onMounted(() => {
  if (props.userEditObj.conditions?.mode) {
    conditionMode.value = props.userEditObj.conditions.mode;
  }
});

function UpdateMode() {
  props.userEditObj.conditions.mode = conditionMode.value;
}
</script>
